import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query';

import { cookieService } from '@services/cookie.service';

import { AppState } from './store';
import { authSlice } from './state/authSlice';

export const isErrorWithObjectMessage = (
  error: unknown,
): error is ErrorType => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'data' in error &&
    typeof (error as any)?.data?.message === 'object'
  );
};

export const isErrorWithStringMessage = (
  error: unknown,
): error is ErrorType => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'data' in error &&
    typeof (error as any)?.data?.message === 'string'
  );
};

export type ErrorType = {
  data?: { message?: string };
};

export const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL}/api/v1`,
  prepareHeaders: async (headers) => {
    const token = cookieService.getAuthToken();

    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    } else {
      // const anonymousId =
      //   cookies.get(ANONYMOUS_USER_ID_KEY) || generateAnonymousUserId();
      // headers.set('x-anonymous-id', anonymousId);
    }

    return headers;
  },
});

export const dynamicBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  const state = api.getState() as AppState;
  const user = state.auth?.user;

  if (result.error && result.error.status === 401 && user) {
    api.dispatch(authSlice.actions.setUser(null));
  }

  return result;
};
